module.exports = __webpack_public_path__ + "img/tech-activity.7bc664b5.svg";